import { Component, OnInit, ElementRef, Renderer2  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Produto, CartItem } from '../tamas-models';
import {AlertaPremiumDialog} from '../alerta-premium';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {ShopProd} from '../tamas-models';

@Component({
  selector: 'app-shop-produto',
  templateUrl: './shop-produto.component.html',
  styleUrls: ['./shop-produto.component.css']
})
export class ShopProdutoComponent implements OnInit {

  hideCL: boolean = false;
  mProduto: ShopProd = new ShopProd();
  //itemProduto: Produto = new Produto;
  categoriaAtual: any = '';
  idProduto: any = 0;
  mUF: any = '';
  mCidade: any = '';
  urlECfoto: any = '';
  arrProdFotos: any[] = [];
  indexAtivo: any = 0;
  prodFotoAtual: any = '';
  novaFoto: boolean = true;
  avoidP: boolean = true;
  hideCrown: boolean = false;
  constructor(private route: ActivatedRoute,private renderer: Renderer2, private _location: Location, public router: Router,  public tmaService: TamasAlunoService,  public dialog: MatDialog) { }

  ngOnInit() {

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' && !this.tmaService.hcPremium || this.tmaService.hcWA && this.tmaService.hcSO == 'android' && !this.tmaService.hcPremium ){
      this.avoidP = true;
    }
    else{
        this.avoidP = false;
    }

    if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' || this.tmaService.hcWA && this.tmaService.hcSO == 'android' ){
      this.hideCrown = true;
    }

    //this.listaProdutos.push({ nome: "100% WHEY GOLD STANDARD", preco: 159.5, precoPremium: 139.9, imagem: 'whey-on-2lb.jpg' })

  
    // this.hideCL = true;
    // this.itemProduto.Nome = "100% WHEY GOLD STANDARD";
    // this.itemProduto.Preco = 159.5;
    // this.itemProduto.PrecoPremium = 119.9;
    // this.itemProduto.Imagem = "whey-on-2lb.jpg";
    
    //check idproduto

    //return from server check uf/cidade
    //true = render else redirect


    //se tiver sabores, retorna os ids e o sabor nessa mesma consulta
    //prodVariacoes[];
    //como criar isso no db? :\
  
    if(this.route.snapshot.paramMap.get('cidade') !== ''){
      this.tmaService.shopCidade = this.route.snapshot.paramMap.get('cidade').replace(/\-/g, ' ');
      this.tmaService.shopUF = this.route.snapshot.paramMap.get('uf');
      this.categoriaAtual = this.route.snapshot.paramMap.get('qcategoria');
      this.mCidade = this.route.snapshot.paramMap.get('cidade').replace(/\-/g, ' ');
      this.mUF = this.route.snapshot.paramMap.get('uf');
      this.idProduto = this.route.snapshot.paramMap.get('idproduto');
      this.carregarProduto();
    }

  }

  carregarProduto() :void{
    var dadosIn = 'cidade=' + this.mCidade + '&uf=' + this.mUF + '&idproduto=' +  this.idProduto;
    this.tmaService.infoShopProd(dadosIn)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.mProduto = qRes['dadosProduto'];
        this.urlECfoto =  this.tmaService.urlRepositorioS3 + "/ecommerce/products/";
        this.prodFotoAtual = this.mProduto.foto;
        this.arrProdFotos.push({foto: this.mProduto.foto});
        if(qRes['fotosProduto'].length > 0){
          //existem fotos
          var prdFotos = qRes['fotosProduto'];
          prdFotos.forEach(element => {
            this.arrProdFotos.push({foto: element.ProdutoFoto });
          });
        }
        // this.arrProdFotos.push({foto: 'tabela-whey-on-2lb.jpg'});
        // this.arrProdFotos.push({foto: this.mProduto.foto});
      }
      
    })
  }

  trocarImg(foto: any, index: any){
    this.novaFoto = false;
    this.indexAtivo = index;
    setTimeout(() => {
      console.log(foto);
      console.log(index);
      this.prodFotoAtual = foto;
    }, 400);
  
    //console.log(element);
    //this.renderer.selectRootElement('#'  + index).value = this.dadosCirc.MedOmbro;
    //this.renderer.addClass('#' + index, 'thumb-active');
    //this.renderer.addClass(element, 'thumb-active');
    //this.renderer.setAttribute(this.elRef.nativeElement, 'class', 'open');


  }

  transitionEnd() {
    this.novaFoto = true;
  }

  addCart() :void{
     //add idloja, tratar isso no carrinho
      //agrupar pordutos por loja
      var fakeCarrinho = [];
      if(this.tmaService.shopCartFull != undefined){
        if(this.tmaService.shopCartFull.length == 0){
          //carrinho vazio
          this.salvarIC();
        }
        
        if(this.tmaService.shopCartFull.find(x => x.idLoja ==  this.mProduto['idloja'])){
          //existe itens dessa loja, adicionamos apenas o produto
          var idxLoja = this.tmaService.shopCartFull.findIndex(x => x.idLoja == this.mProduto['idloja']);
          this.tmaService.shopCartFull[idxLoja].arrProdutos.push({idProduto: this.idProduto, qtdProduto: 1, prodPreco: this.mProduto['precoN'], prodPrecoPremium: this.mProduto['precoV'], nomeProduto: this.mProduto['nome'], fotoProduto: this.mProduto['foto'], idLoja:  this.mProduto['idloja']});
          //salvar na localstorage para questões de resgatar o carrinho
          localStorage['tmsCarrinho'] = JSON.stringify(this.tmaService.shopCartFull);
          //fakeCarrinho.push({idProduto: this.idProduto, qtdProduto: 1, prodPreco: this.mProduto['precoN'], prodPrecoPremium: this.mProduto['precoV'], nomeProduto: this.mProduto['nome'], fotoProduto: this.mProduto['foto'], idLoja:  this.mProduto['idloja']});
          //this.tmaService.shopCarrinho.push({ idProduto: this.idProduto, qtdProduto: 1, prodPreco: this.mProduto['precoN'], prodPrecoPremium: this.mProduto['precoV'], nomeProduto: this.mProduto['nome'], fotoProduto: this.mProduto['foto'], idLoja:  this.mProduto['idloja'] });
          //this.tmaService.shopCartFull.push({ idLoja: this.tmaService.shopLojaAtual, arrProdutos: this.tmaService.shopCarrinho, cartUF: this.tmaService.shopUF, cartCidade: this.tmaService.shopCidade });
          //this.tmaService.shopCartFull.push({ idLoja:  this.mProduto['idloja'], arrProdutos:fakeCarrinho, cartUF: this.tmaService.shopUF, cartCidade: this.tmaService.shopCidade });
        }
        else{
          //não existe
          //primeiro item - chamar a call lembrete
         
          fakeCarrinho.push({idProduto: this.idProduto, qtdProduto: 1, prodPreco: this.mProduto['precoN'], prodPrecoPremium: this.mProduto['precoV'], nomeProduto: this.mProduto['nome'], fotoProduto: this.mProduto['foto'], idLoja:  this.mProduto['idloja']});
          //this.tmaService.shopCarrinho.push({ idProduto: this.idProduto, qtdProduto: 1, prodPreco: this.mProduto['precoN'], prodPrecoPremium: this.mProduto['precoV'], nomeProduto: this.mProduto['nome'], fotoProduto: this.mProduto['foto'], idLoja:  this.mProduto['idloja'] });
          //this.tmaService.shopCartFull.push({ idLoja: this.tmaService.shopLojaAtual, arrProdutos: this.tmaService.shopCarrinho, cartUF: this.tmaService.shopUF, cartCidade: this.tmaService.shopCidade });
          this.tmaService.shopCartFull.push({ idLoja:  this.mProduto['idloja'], arrProdutos: fakeCarrinho, cartUF: this.tmaService.shopUF, cartCidade: this.tmaService.shopCidade });
        //salvar na localstorage para questões de resgatar o carrinho
          localStorage['tmsCarrinho'] = JSON.stringify(this.tmaService.shopCartFull);
        }
      }
      
    

      


      // if(this.idProduto == 1){
      //   this.tmaService.shopCarrinho.push({ idProduto: this.idProduto, qtdProduto: 1, prodPreco: this.itemProduto.Preco, prodPrecoPremium: this.itemProduto.PrecoPremium, nomeProduto: '100% Whey Gold Standard', fotoProduto: this.itemProduto.Imagem, idLoja: this.tmaService.shopLojaAtual });
      //   this.tmaService.shopCartFull.push({ idLoja: this.tmaService.shopLojaAtual, arrProdutos: this.tmaService.shopCarrinho, cartUF: this.tmaService.shopUF, cartCidade: this.tmaService.shopCidade });
      // }
      // else{
      //   this.tmaService.shopCarrinho.push({ idProduto: this.idProduto, qtdProduto: 1, prodPreco: this.itemProduto.Preco, prodPrecoPremium: this.itemProduto.PrecoPremium, nomeProduto: '100% Whey Gold Standard', fotoProduto: this.itemProduto.Imagem, idLoja: 2 });
      //   this.tmaService.shopCartFull.push({ idLoja: 2, arrProdutos: this.tmaService.shopCarrinho, cartUF: this.tmaService.shopUF, cartCidade: this.tmaService.shopCidade });
      // }
      
      
      if(this.tmaService.shopUrlAnterior == ''){
        this.router.navigate(['shopping/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/' + this.categoriaAtual]);
      }
      else{
        this.router.navigate([this.tmaService.shopUrlAnterior]);
      }
      
 }


  salvarIC() :void{
    console.log("call ic");
    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idproduto: this.idProduto
    };
    this.tmaService.salvarICart(customParams).subscribe();
  }

  //alerta premium
  showVAP() :void{
    const alertaInfoPremium = this.dialog.open(AlertaPremiumDialog, {
      //width: '300px',
      data: {origem: "shopping"}
    });
    alertaInfoPremium.afterClosed().subscribe(result => {
      console.log(result);
      if(result == 1){
        //saber mais
      }
      if(result == 2){
        //assinar
        this.router.navigate(['/premium']);
      }
    });
  }

  voltar() :void{
    //this._location.back();
    if(this.tmaService.shopUrlAnterior == ''){
      this.router.navigate(['shopping/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') + '/' + this.categoriaAtual]);
    }
    else{
      this.router.navigate([this.tmaService.shopUrlAnterior]);
    }
  }

}
